import {useAppSelector} from "hooks";
import {Body, buildTheme} from "styles";
import {useContextTheme} from "context";
import {Global, Helpers} from "components";
import {navigationConfig} from "navigation";
import {ThemeProvider} from "styled-components";
import {Route, Routes, BrowserRouter} from "react-router-dom";

function App() {
  const theme = useContextTheme();
  const {isLogged} = useAppSelector("auth");
  const {routes, Layout} = navigationConfig(isLogged);

  return (
    <ThemeProvider theme={buildTheme(theme)}>
      <BrowserRouter>
        <Body>
          <Layout>
            <Routes
              children={routes.map(({path, element}, key) => (
                <Route key={key} path={path} element={element} />
              ))}
            />
          </Layout>
        </Body>
        <Global />
        <Helpers />
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
